import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiEndpoints } from '../../constants/api-endpoints';
import { HttpUtilityService } from '../http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class DelegationService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  searchDelegations(body?: any): Observable<HttpResponse<any[]>> {
    return this.httpUtilityService.post<any[]>(
      apiEndpoints.searchDelegations,
      body
    );
  }

  deleteDelegations(delIds: number[]): Observable<HttpResponse<any>> {
    const body = { delId: delIds };
    return this.httpUtilityService.post<any>(
      apiEndpoints.delegationDelete,
      body
    );
  }
  saveDelegation(data: any): Observable<any> {
    return this.httpUtilityService.post<any>(apiEndpoints.delegationSave, data);
  }

  getDelegates(): Observable<HttpResponse<any[]>> {
    return this.httpUtilityService.get<any[]>(apiEndpoints.getDelegation);
  }
}
